import React from "react";
import styles from "./FinanceWorkPanel.module.less";
const FinanceWorkPanel = () => {
    const microUrl = process.env.REACT_APP_FINANCE_WORK_PANEL_URL;
    return (
        <div className={styles.finance_micro__div}>
            <micro-app
                name="financeWorkPanel"
                url={microUrl}
                disableScopecss='true'
                baseroute="/micro-apps"
            ></micro-app>
        </div>
    );
};

export default FinanceWorkPanel;
